module.exports = __webpack_public_path__ + "lendo-case-bg.69f63afe83f526c69368.svg";